import React from "react";

export default function E8SquareGridAreaDiagram({ data }) {
  const size = 170;
  const margin = 42;
  const width = size + 2 * margin;
  const height = size + 2 * margin;
  const x0 = margin;
  const y0 = margin;
  const x1 = x0 + size;
  const y1 = y0 + size;
  const fX = x0 + (data.fFromD / data.horizontalParts) * size;
  const eY = y1 - (data.eFromB / data.verticalParts) * size;
  const line = "currentColor";
  const accent = "#f0ad3d";
  const tick = 5.5;
  const letter = {
    fill: line,
    fontFamily: "serif",
    fontStyle: "italic",
    fontSize: 14.5,
    fontWeight: 500,
    textAnchor: "middle",
    dominantBaseline: "middle",
  };

  const hTicks = Array.from(
    { length: data.horizontalParts + 1 },
    (_, i) => x0 + (i / data.horizontalParts) * size
  );
  const vTicks = Array.from(
    { length: data.verticalParts + 1 },
    (_, i) => y1 - (i / data.verticalParts) * size
  );

  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "12px 0 16px" }}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        role="img"
        aria-label="Kwadrat z zaznaczonym czworokątem AECF"
        style={{ width: "min(100%, 285px)", height: "auto" }}
      >
        <polygon
          points={`${x0},${y1} ${x1},${eY} ${x1},${y0} ${fX},${y0}`}
          fill="rgba(240,173,61,0.22)"
          stroke="none"
        />

        <rect x={x0} y={y0} width={size} height={size} fill="none" stroke={line} strokeWidth="1.8" />
        <line x1={x0} y1={y1} x2={x1} y2={eY} stroke={accent} strokeWidth="2.2" />
        <line x1={x0} y1={y1} x2={fX} y2={y0} stroke={accent} strokeWidth="2.2" />
        <line x1={fX} y1={y0} x2={x1} y2={y0} stroke={accent} strokeWidth="2.2" />
        <line x1={x1} y1={y0} x2={x1} y2={eY} stroke={accent} strokeWidth="2.2" />

        {hTicks.map((x) => (
          <g key={`h-${x}`}>
            <line x1={x} y1={y1 - tick} x2={x} y2={y1 + tick} stroke={line} strokeWidth="1.5" />
            <line x1={x} y1={y0 - tick} x2={x} y2={y0 + tick} stroke={line} strokeWidth="1.5" />
          </g>
        ))}
        {vTicks.map((y) => (
          <g key={`v-${y}`}>
            <line x1={x0 - tick} y1={y} x2={x0 + tick} y2={y} stroke={line} strokeWidth="1.5" />
            <line x1={x1 - tick} y1={y} x2={x1 + tick} y2={y} stroke={line} strokeWidth="1.5" />
          </g>
        ))}

        <text x={x0 - 12} y={y1 + 14} style={letter}>A</text>
        <text x={x1 + 12} y={y1 + 14} style={letter}>B</text>
        <text x={x1 + 12} y={y0 - 10} style={letter}>C</text>
        <text x={x0 - 12} y={y0 - 10} style={letter}>D</text>
        <text x={x1 + 12} y={eY + 1} style={letter}>E</text>
        <text x={fX} y={y0 - 12} style={letter}>F</text>
      </svg>
    </div>
  );
}
